/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SharedTrackingContainer_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "SharedTrackingContainer_user";
};
export type SharedTrackingContainer_user$data = SharedTrackingContainer_user;
export type SharedTrackingContainer_user$key = {
    readonly " $data"?: SharedTrackingContainer_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SharedTrackingContainer_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedTrackingContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'd2801a05d6c3b022ead4351dee42082d';
export default node;
